import script from "./Level0.vue?vue&type=script&setup=true&lang=js"
export * from "./Level0.vue?vue&type=script&setup=true&lang=js"

import "./Level0.vue?vue&type=style&index=0&id=0562e230&scoped=true&lang=css"

import exportComponent from "/home/alan-liang/Code/misc/GGJ22/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0562e230"]])

export default __exports__